import normal from './normal';
import horizontal from './horizontal';
import vertical from './vertical';
import mute from './mute';
import links from '@solid-ui-theme/links';

export default {
  normal,
  mute,
  vertical,
  horizontal,
  'nav-dark': links['nav-dark'],
  'nav-dark-underline': links['nav-dark-underline'],
  'nav-dark-small': links['nav-dark-small'],
  'nav-light': links['nav-light'],
  transparent: links['transparent'],
};
